// extracted by mini-css-extract-plugin
module.exports = {"cover":"ShelfImageItem_cover__3xEyl","doublecover":"ShelfImageItem_doublecover__2lQR7"};